// extracted by mini-css-extract-plugin
var _1 = "src-components-automation-Process-module__activity";
var _2 = "src-components-automation-Process-module__activityName";
var _3 = "src-components-automation-Process-module__activityProgress";
var _4 = "src-components-automation-Process-module__activityState";
var _5 = "src-components-automation-Process-module__cancelled";
var _6 = "src-components-automation-Process-module__completed";
var _7 = "src-components-automation-Process-module__failed";
var _8 = "src-components-automation-Process-module__pending";
var _9 = "src-components-automation-Process-module__process";
var _a = "src-components-automation-Process-module__running";
export { _1 as "activity", _2 as "activityName", _3 as "activityProgress", _4 as "activityState", _5 as "cancelled", _6 as "completed", _7 as "failed", _8 as "pending", _9 as "process", _a as "running" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"activity\":\"src-components-automation-Process-module__activity\",\"activityName\":\"src-components-automation-Process-module__activityName\",\"activityProgress\":\"src-components-automation-Process-module__activityProgress\",\"activityState\":\"src-components-automation-Process-module__activityState\",\"cancelled\":\"src-components-automation-Process-module__cancelled\",\"completed\":\"src-components-automation-Process-module__completed\",\"failed\":\"src-components-automation-Process-module__failed\",\"pending\":\"src-components-automation-Process-module__pending\",\"process\":\"src-components-automation-Process-module__process\",\"running\":\"src-components-automation-Process-module__running\"}";
        // 1772132917913
        var cssReload = require("../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  